import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2, AlertCircle, Mail } from 'lucide-react';
import { peekPostLoginRedirect } from '../utils/postLoginRedirect';

const Login: React.FC = () => {
  const { login, isLoading } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();
  const isFromEmail =
    (location.state as { fromEmail?: boolean })?.fromEmail ||
    peekPostLoginRedirect()?.fromEmail === true;

  const handleLogin = async () => {
    try {
      setError(null);
      await login();
    } catch (err) {
      console.error('Erro no login:', err);
      setError('Erro ao fazer login. Tente novamente.');
    }
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8'>
      <div className='max-w-md w-full space-y-8'>
        <div>
          <div className='mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-primary-100'>
            <svg
              className='h-8 w-8 text-primary-600'
              fill='none'
              stroke='currentColor'
              viewBox='0 0 24 24'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
              />
            </svg>
          </div>
          <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>GMUD Manager</h2>
          {isFromEmail ? (
            <div className='mt-2 text-center'>
              <p className='text-sm text-gray-600 flex items-center justify-center gap-2'>
                <Mail className='h-4 w-4 text-blue-600' />
                Você foi redirecionado de um email
              </p>
              <p className='text-sm text-gray-600 mt-1'>
                Faça login para acessar diretamente o conteúdo
              </p>
            </div>
          ) : (
            <p className='mt-2 text-center text-sm text-gray-600'>
              Faça login para acessar o sistema
            </p>
          )}
        </div>

        <div className='mt-8 space-y-6'>
          <div>
            {error && (
              <div className='mb-4 p-3 bg-red-50 border border-red-200 rounded-md flex items-center gap-2 text-red-700'>
                <AlertCircle className='h-4 w-4' />
                <span className='text-sm'>{error}</span>
              </div>
            )}
            <button
              onClick={handleLogin}
              disabled={isLoading}
              className='group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500-500 disabled:opacity-50 disabled:cursor-not-allowed'
            >
              {isLoading ? (
                <Loader2 className='h-5 w-5 animate-spin' />
              ) : (
                <>
                  <svg className='w-5 h-5 mr-2' viewBox='0 0 24 24' fill='currentColor'>
                    <path d='M11.5 2.75a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zM2.75 12a8.75 8.75 0 0117.5 0 8.75 8.75 0 01-17.5 0z' />
                    <path d='M12 6.75a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zM6.75 12a5.25 5.25 0 0110.5 0 5.25 5.25 0 01-10.5 0z' />
                  </svg>
                  Entrar com Microsoft
                </>
              )}
            </button>
          </div>

          <div className='text-center'>
            <p className='text-xs text-gray-500'>
              Ao fazer login, você concorda com nossos termos de uso e política de privacidade.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
